<template>
    <div class="page page-bag">
        <div v-if="!userinfo.phone" class="user-info user-info1">
            <strong>您尚未登录</strong>
            <span class="login" @click="loginShow">立即登录</span>
        </div>
        <div v-else class="user-info user-info2">
            <strong>{{ userinfo.phone }}</strong>
            <span class="logout" @click="loginShow"></span>
            <span class="bind" @click="bindsShow">绑定角色</span>
        </div>
        <div class="back" @click="$router.replace('/game/scene')"></div>
        <div :class='gifts.length>0?"btn btn-get":"btn btn-get disabled"' @click="acceptAllRewards"></div>
        <div class="btn btn-record" @click="getRewards"></div>
        <div class="bag-wrapper">
            <ul class="tabs">
                <li :class='index === 0 ? "active" : ""' @click="tabChange(0)">
                    <strong></strong>
                </li>
                <li :class='index === 1 ? "active" : ""' @click="tabChange(1)">
                    <strong></strong>
                </li>
            </ul>
            <div class="filter-wrapper">
                <div class="reward-wrapper" :style='`left:${-index * 6.46}rem`'>
                    <!-- 旅途奖励内容 -->
                    <div class="reward reward-1">
                        <ul v-if="lvturewards.length">
                            <li v-for="item in lvturewards" :key="item.itemid">
                                <div :class='item.isitem === 0 ? `img-wrapper img-wrapper1` : `img-wrapper`'>
                                    <div class="btn-address" v-if="item.isitem === 0 && !myaddress.name"
                                        @click="showPop('addresscheckshow')"></div>
                                    <div class="btn-address btn-address-add" v-if="item.isitem === 0 && myaddress.name"
                                        @click="showPop('myaddressshow')"></div>
                                    <img :src='item | rewardIconFilter' />
                                </div>
                                <h4>{{ item | rewardNameFilter }}×{{ item.counts }}</h4>
                            </li>
                        </ul>
                        <div v-else class="blank-wrapper">
                            <div class="blank">
                                <div></div>
                                <p>您暂未获得任何奖励~</p>
                            </div>
                        </div>
                    </div>
                    <!-- 伙伴赠礼内容 -->
                    <div class="reward reward-2">
                        <ul class="teams-wrapper">
                            <li class="team" v-for="(item, index) in hubarewards" :key="item.id">
                                <div class="items-wrapper">
                                    <h2 :class='`title-${index+1}`'></h2>
                                    <ul class="items">
                                        <li v-for="role in item.list" :key="role.roleid">
                                            <div class="img-wrapper">
                                                <img :class='role.isget ? "" : "filter"'
                                                    :src='`https://static.web.sdo.com/xuezu/pic/20221201_Game/roles/${role.roleid}.png`'
                                                    alt="" />
                                            </div>
                                            <h4>{{ role | rewardRoleName }}</h4>
                                        </li>
                                    </ul>
                                </div>
                                <div class="gift">
                                    <div class="img-wrapper">
                                        <i v-if="item.isget === 0"></i>
                                        <i v-else class="done"></i>
                                        <img :class='item.isget === 0 ? "filter" : ""'
                                            :src='`https://static.web.sdo.com/xuezu/pic/20221201_Game/rewards/${item.id}.png`'
                                            alt="">
                                    </div>
                                    <div class="btn" @click="AcceptConfirm(1, item.rewardid, index)"
                                        v-if="item.isget === 1"></div>
                                    <div class="btn done" v-else-if="item.isget === 2"></div>
                                    <div class="btn disabled" v-else></div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 领奖记录 -->
        <div id="rewardsPop" class="pop" v-show="rewardslogshow">
            <div class="content">
                <span class="close" @click="closePop('rewardslogshow')"></span>
                <div class="rewards-wrapper">
                    <ul v-if="rewardlogs.length">
                        <li v-for="item in rewardlogs" :key="item.date">
                            <h2>{{ item.date }}</h2>
                            <p>
                                {{ item.content }}
                            </p>
                        </li>
                    </ul>
                    <div class="blank" v-else>暂时没有任何领奖记录</div>
                </div>
            </div>
        </div>
        <!-- 收获地址登记 -->
        <div id="addressCheckPop" v-show="addresscheckshow" class="pop" @click="closePop('addressnoteshow')">
            <div class="content">
                <span class="close" @click="closePop('addresscheckshow')"></span>
                <div class="btn-note" @click.stop="showAddressNote"></div>
                <div class="note-wrapper" v-show="addressnoteshow">
                    <div class="row">
                        <span>1、</span>
                        <p>目前地址信息仅支持填写一次，确认提交之后将无法再次自主修改。若因不可控因素出现误填情况，请在2023年1月30日前联系客服QQ925521270沟通确认后进行修改。</p>
                    </div>
                    <div class="row">
                        <span>2、</span>
                        <p>2023年1月20日23:59后，将无法再填写地址信息。若超时未填写地址则默认放弃奖励，请血裔们及时填写。</p>
                    </div>
                    <div class="row">
                        <span>2、</span>
                        <p>实物奖品配送区域范围目前仅限中国大陆地区（港/澳/台地区及海外地区除外）请获奖的血裔填写配送范围内的地址。</p>
                    </div>
                </div>
                <div class="input-wrapper">
                    <input type="text" v-model.trim="myaddress.name" placeholder="请输入收件人姓名">
                </div>
                <div class="input-wrapper">
                    <input type="tel" v-model.trim="myaddress.phone" placeholder="请输入手机号码">
                </div>
                <div class="input-wrapper textarea-wrapper">
                    <textarea v-model.trim="myaddress.addr" placeholder="请输入详细地址"></textarea>
                </div>
                <div class="input-wrapper">
                    <input type="tel" v-model.trim="myaddress.gameid" placeholder="请输入游戏ID">
                </div>
                <div class="btn-confirm" @click="checkAddress"></div>
                <div class="tips">
                    请及时完成登记，奖励将于活动结束后30个工作日内安排寄送
                </div>
            </div>
        </div>
        <!-- 收获地址确认 -->
        <div id="addressConfirmPop" v-show="addressconfirmshow" class="pop">
            <div class="content">
                <span class="close" @click="closePop('addressconfirmshow')"></span>
                <h1>
                    收货地址一经确认无法更改，<br />是否确认登记？
                </h1>
                <ul class="btns-wrapper">
                    <li @click="cancelEvent"></li>
                    <li @click="submitEvent"></li>
                </ul>
            </div>
        </div>
        <!-- 我的收货地址 -->
        <div id="myAddressPop" v-show="myaddressshow" class="pop">
            <div class="content">
                <span class="close" @click="closePop('myaddressshow')"></span>
                <ul>
                    <li><span>收件人</span><strong>{{ myaddress.name }}</strong></li>
                    <li><span>手机号</span><strong>{{ myaddress.phone }}</strong></li>
                    <li><span>详细地址</span>
                        <strong>
                            {{ myaddress.addr }}
                        </strong>
                    </li>
                    <li><span>游戏ID</span><strong>{{ myaddress.gameid || "---" }}</strong></li>
                </ul>
            </div>
        </div>
        <!-- 领奖弹窗 -->
        <div id="getRewardsPop" v-show="allrewardsshow" class="pop">
            <div class="content">
                <span class="close" @click="closePop('allrewardsshow')"></span>
                <h1>您即将把以下<strong>{{ gifts.length }}</strong>项奖励领取至已绑定游戏角色中</h1>
                <MySwiper class="myswiper" :list="gifts" />
                <ul class="btns-wrapper">
                    <li @click="closePop('allrewardsshow')"></li>
                    <li @click="AcceptConfirm(0)"></li>
                </ul>
                <div class="tips">
                    奖励发放可能存在延迟，请耐心等待10分钟左右
                </div>
            </div>
        </div>
        <!-- 领奖确认 -->
        <div id="getRewardConfirmPop" v-show="rewardsconfirmshow" class="pop">
            <div class="content">
                <span class="close" @click="closePop('rewardsconfirmshow')"></span>
                <h1>
                    您还有<strong>{{ 3 - bindlist.list.length }}</strong>次绑定游戏角色的机会，<br />
                    奖励一经领取将无法新增角色绑定，<br />
                    是否仍要领取奖励？
                </h1>
                <ul class="btns-wrapper">
                    <li @click="closePop('rewardsconfirmshow')"></li>
                    <li @click="RewardAccept"></li>
                </ul>
                <div class="btn-bind" @click="goBind"></div>
            </div>
        </div>
        <!-- 领取成功 -->
        <div id="getRewardsSuccessPop" v-show="rewardssuccessshow" class="pop">
            <div class="content">
                <span class="close" @click="closePop('rewardssuccessshow')"></span>
                <h1>奖励领取成功</h1>
                <p>请至游戏角色邮箱中查看~</p>
                <p>奖励发放可能存在延迟，请耐心等待10分钟左右</p>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapMutations } from 'vuex'
import { GetGroups, GetFriends } from '../../../utils'
import { GetRewardsList, GetRunRewards, GetAddress, SetAddress, AcceptRewards } from '../../../api'
import mixins from '../../../mixins'
import MySwiper from '../../../components/swiper'
export default {
    name: 'MyBag',
    mixins: [mixins],
    computed: {
        ...mapState(['userinfo', 'bindlist']),
        gifts() {
            return this.lvturewards.filter(item => item.isitem === 1);
        }
    },
    components: { MySwiper },
    data() {
        return {
            index: 0,
            allrewardsshow: false, // 一键领取奖励明细
            addresscheckshow: false, // 地址登记
            addressconfirmshow: false, // 地址确认
            myaddressshow: false, // 我的登记地址
            addressnoteshow: false, // 地址登记须知
            myaddress: {
                name: '',
                phone: '',
                addr: '',
                gameid: ''
            },
            rewardslogshow: false, // 领奖记录
            rewardsconfirmshow: false, // 领取确认弹窗
            rewardssuccessshow: false, // 领取成功弹窗
            rewardlogs: [],  // 领奖记录信息
            lvturewards: [],  // 旅途奖励信息
            hubarewards: [],   // 伙伴赠礼信息
            rewardtype: 0,  // 领奖方式（0一键领取 其他为单向领取）
            selected: {
                id: "",
                index: 0
            }
        }
    },
    methods: {
        ...mapMutations({ loginShow: 'LOGINSHOW', bindsShow: 'BINDSSHOW' }),
        tabChange(index) {
            this.index = index;
        },
        showAddressNote() {
            this.addressnoteshow = !this.addressnoteshow;
        },
        goBind(){
            this.rewardsconfirmshow=false;
            this.bindsShow();
        },
        async getRewards() {
            const res = await GetRewardsList();
            if (res) {
                this.rewardslogshow = true;
                this.rewardlogs = res.logs;
            }
        },
        checkAddress() {
            if (!this.myaddress.name) {
                return CsLib.alert('收件人信息不能为空！', 'error');
            }
            if (!/^1\d{10}$/.test(this.myaddress.phone)) {
                return CsLib.alert('手机号码格式不正确！', 'error');
            }
            if (!this.myaddress.addr) {
                return CsLib.alert('详细地址不能为空！', 'error');
            }
            this.addresscheckshow = false;
            this.addressconfirmshow = true;
        },
        cancelEvent() {
            this.addresscheckshow = true;
            this.addressconfirmshow = false;
        },
        async submitEvent() {
            const res = await SetAddress(this.myaddress.name, this.myaddress.phone, this.myaddress.addr, this.myaddress.gameid);
            if (res) {
                this.addressconfirmshow = false;
                this.myaddressshow = true;
                CsLib.alert('地址提交成功');
            }
        },
        acceptAllRewards() {
            if (this.bindlist.list.length <= 0) {
                return this.bindsShow();
            }
            if (this.gifts.length === 0) {
                return CsLib.alert('您目前没有任何道具奖励', 'error');
            }
            this.allrewardsshow = true;
        },
        AcceptConfirm(type, id, index) {
            // 绑定未锁定
            this.allrewardsshow = false;
            // 奖励类型
            this.rewardtype = type;
            // 单向奖励传值
            this.selected.id = id;
            this.selected.index = index;
            if (this.userinfo.bindlock === 0) {
                if(this.bindlist.list.length===0){
                    return this.bindsShow();
                }
                if (this.bindlist.list.length < 3) {
                    this.rewardsconfirmshow = true;
                    return false;
                } else {
                    if (type === 0) {
                        // 一键领取全部
                        this.getAllRewards();
                    } else {
                        // 单向领取
                        this.getItemReward();
                    }
                }
            } else {
                if (type === 0) {
                    // 一键领取全部
                    this.getAllRewards();
                } else {
                    // 单向领取
                    this.getItemReward();
                }
            }
        },
        RewardAccept() {
            if (this.rewardtype === 0) {
                this.getAllRewards();
            } else {
                this.getItemReward();
            }
        },
        async getAllRewards() {
            const res = await AcceptRewards(0);
            if (res) {
                this.rewardsconfirmshow = false;
                this.rewardssuccessshow = true;
                this.userinfo.bindlock = 1;
                // 旅途奖励清除道具奖励
                this.lvturewards = this.lvturewards.filter(item => item.isitem === 0);
            }
        },
        async getItemReward() {
            const res = await AcceptRewards(this.selected.id);
            if (res) {
                this.rewardsconfirmshow = false;
                this.rewardssuccessshow = true;
                this.userinfo.bindlock = 1;
                this.hubarewards[this.selected.index].isget = 2;
            }
        },
        async getRunRewards() {
            const res = await GetRunRewards();
            if (res) {
                this.lvturewards = GetGroups(res.items);
                this.hubarewards = GetFriends(res.roles, res.get);
            }
        },
        async getAddress() {
            const res = await GetAddress();
            if (res) {
                this.myaddress = res;
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.path === "/") {
                vm.$router.replace('/');
            }
        })
    },
    mounted() {
        this.getRunRewards();
        this.getAddress();
    }
}
</script>

<style lang="scss" scoped>
.icon {
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/icon.png');
    background-size: 20rem 20rem;
    background-repeat: no-repeat;
}

.page-bag {
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/3.jpg');
    box-sizing: border-box;
    padding-top: 4.10rem;
    min-height:auto;
    .user-info {
        strong {
            color: #000;
        }
    }
}

.back {
    position: absolute;
    width: 1.82rem;
    height: 0.74rem;
    left: 0rem;
    top: 0rem;
    z-index: 1;
}

.btn {
    position: absolute;
    @extend .icon;
    z-index: 1;

    &.btn-get {
        width: 2.96rem;
        height: 0.9rem;
        top: 2.23rem;
        right: 0.37rem;
        background-position: -5.34rem -2.67rem;
        &.disabled{
            filter: grayscale(100);
        }
    }

    &.btn-record {
        width: 1.54rem;
        height: 0.34rem;
        top: 3.4rem;
        right: 1rem;
        background-position: -8.49rem -2.68rem;
    }
}

.bag-wrapper {
    padding-left: 0.42rem;
    padding-right: 0.44rem;

    .tabs {
        display: flex;
        height: 0.86rem;
        line-height: 0.86rem;
        text-align: center;

        li {
            flex-grow: 1;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            &::before {
                background-color: #5757df;
                z-index: 0;
                position: absolute;
                content: "";
                left: -0.04rem;
                top: -0.01rem;
                right: -0.02rem;
                height: 101%;
            }

            strong {
                position: relative;
                z-index: 1;
                display: block;
                @extend .icon;
            }

            &:nth-of-type(1) {
                strong {
                    width: 1.42rem;
                    height: 0.34rem;
                    background-position: -8.76rem -11.14rem;
                }

                &.active {
                    strong {
                        background-position: -8.76rem -11.81rem;
                    }
                }
            }

            &:nth-of-type(2) {
                strong {
                    width: 1.42rem;
                    height: 0.34rem;
                    background-position: -10.58rem -11.14rem;
                }

                &.active {
                    strong {
                        background-position: -10.58rem -11.81rem;
                    }
                }
            }

            &.active {
                color: #fff;

                &::before {
                    background-color: #faeeb4;
                }
            }
        }
    }

    .filter-wrapper {
        overflow: hidden;
        width: 6.64rem;
        margin: 0rem auto;

        .reward-wrapper {
            position: relative;
            display: flex;
            width: 13.28rem;
            box-sizing: border-box;
            padding-top: 0.4rem;
            transition: all 0.3s;
            left: 0rem;

            .reward {
                width: 6.64rem;
                height: calc(100vh - 5.6rem);
                box-sizing: border-box;
                padding-bottom: 0.32rem;
                overflow: scroll;
            }

            .reward-1 {
                .blank-wrapper {
                    text-align: center;
                    padding-top: 1rem;
                    .blank {
                        div {
                            @extend .icon;
                            display: block;
                            width: 1.9rem;
                            height: 2.11rem;
                            margin: 0rem auto 0.12rem auto;
                            background-position: 0rem -10.55rem;
                        }
                    }
                }

                ul {
                    display: flex;
                    flex-wrap: wrap;

                    li {
                        width: 2.2rem;
                        margin-bottom: 0.26rem;
                    }
                }

                .img-wrapper {
                    position: relative;
                    width: 1.65rem;
                    height: 1.55rem;
                    display: flex;
                    margin: 0rem auto;
                    justify-content: center;
                    align-items: center;
                    @extend .icon;
                    background-position: -12.96rem -2.8rem;

                    &.img-wrapper1 {
                        background-position: -11.12rem -2.8rem;

                        .btn-address {
                            position: absolute;
                            @extend .icon;
                            width: 1.54rem;
                            height: 0.41rem;
                            left: 50%;
                            margin-left: -0.77rem;
                            bottom: 0.06rem;
                            background-position: -13.96rem -1.81rem;

                            &.btn-address-add {
                                background-position: -12.11rem -1.81rem;
                            }
                        }
                    }

                    img {
                        width: 1.2rem;
                    }
                }

                h4 {
                    text-align: center;
                    margin-top: 0.1rem;
                }
            }

            .reward-2 {
                .teams-wrapper {
                    padding: 0rem 0.24rem;

                    .team {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 0.5rem;

                        &:nth-last-of-type(1) {
                            margin-bottom: 0rem;
                        }

                        h2 {
                            width: 3.2rem;
                            height: 0.28rem;
                            @extend .icon;
                            margin: 0rem auto 0.12rem auto;
                            &.title-1{
                                background-position: -11.28rem -15.59rem;
                            }
                            &.title-2{
                                background-position: -11.28rem -16.17rem;
                            }
                            &.title-3{
                                background-position: -11.28rem -16.73rem;
                            }
                            &.title-4{
                                background-position: -11.28rem -17.31rem;
                            }
                            &.title-5{
                                background-position: -11.28rem -17.84rem;
                            }
                        }

                        ul {
                            display: flex;
                            width: 3.8rem;
                            justify-content: space-between;
                            position: relative;

                            &::after {
                                position: absolute;
                                content: "";
                                @extend .icon;
                                width: 0.28rem;
                                height: 0.42rem;
                                background-position: -18.32rem -0.01rem;
                                right: -0.54rem;
                                top: 0.2rem;
                            }

                            li {
                                .img-wrapper {
                                    width: 1.15rem;
                                    height: 1.05rem;
                                    position: relative;

                                    &::before {
                                        position: absolute;
                                        content: "";
                                        width: 100%;
                                        height: 100%;
                                        z-index: 2;
                                        @extend .icon;
                                        left: 0rem;
                                        top: 0rem;
                                        background-position: -5.37rem -6.45rem;
                                    }

                                    &::after {
                                        position: absolute;
                                        content: "";
                                        width: 1rem;
                                        height: 0.92rem;
                                        z-index: 0;
                                        @extend .icon;
                                        left: 0.07rem;
                                        top: 0.08rem;
                                        background-position: -6.82rem -6.46rem;
                                    }

                                    img {
                                        width: 1rem;
                                        height: 0.92rem;
                                        position: absolute;
                                        z-index: 1;
                                        left: 0.07rem;
                                        top: 0.08rem;

                                        &.filter {
                                            filter: grayscale(100);
                                            opacity: 0.65;
                                        }
                                    }
                                }

                                h4 {
                                    font-size: 0.26rem;
                                    font-weight: normal;
                                    text-align: center;
                                    margin-top: 0.12rem;
                                }
                            }
                        }

                        .gift {
                            position: relative;

                            .img-wrapper {
                                width: 1.74rem;
                                height: 1.55rem;

                                img {
                                    vertical-align: middle;
                                    width: 100%;

                                    &.filter {
                                        filter: grayscale(100);
                                        opacity: 0.65;
                                    }
                                }
                            }

                            .btn {
                                width: 1.16rem;
                                height: 0.42rem;
                                @extend .icon;
                                background-position: -15.76rem -1.81rem;
                                margin: 0.2rem auto 0rem auto;
                                position: relative;

                                &.disabled {
                                    background-position: -18.60rem -1.81rem;
                                }

                                &.done {
                                    background-position: -17.18rem -1.81rem;
                                }
                            }

                            i {
                                position: absolute;
                                @extend .icon;
                                width: 0.28rem;
                                height: 0.72rem;
                                background-position: -9.88rem -4.06rem;
                                top: 0.12rem;
                                right: 0.12rem;
                                z-index: 2;

                                &.done {
                                    background-position: -10.44rem -4.06rem;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

#rewardsPop {
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/rewardsPop.png');
        width: 7.02rem;
        height: 7.28rem;
        margin-left: -3.51rem;
        margin-top: -3.64rem;
        box-sizing: border-box;
        padding: 1.54rem 0.72rem 0rem 0.72rem;

        .rewards-wrapper {
            max-height: 5.3rem;
            overflow: scroll;
        }

        ul {
            li {
                position: relative;
                padding-left: 0.36rem;
                margin-bottom: 0.32rem;

                &::before {
                    position: absolute;
                    content: "";
                    width: 0.22rem;
                    height: 0.22rem;
                    @extend .icon;
                    left: 0rem;
                    top: 0.04rem;
                    background-position: -14.91rem -3.37rem;
                }

                &:last-of-type {
                    margin-bottom: 0rem;
                }

                h2 {
                    font-size: 0.28rem;
                    color: #de381d;
                    margin-bottom: 0.1rem;
                }

                p {
                    font-size: 0.24rem;
                    color: #151515;
                    line-height: 1.4;
                }
            }
        }

        .blank {
            text-align: center;
            padding-top: 1.6rem;
        }
    }
}

#addressCheckPop {
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/addressCheckPop.png');
        width: 7.02rem;
        height: 8.58rem;
        margin-left: -3.51rem;
        margin-top: -4.29rem;
        box-sizing: border-box;
        padding-top: 2.05rem;

        .btn-note {
            position: absolute;
            width: 1.52rem;
            height: 0.34rem;
            z-index: 1;
            left: 2.76rem;
            top: 1.38rem;
        }

        .note-wrapper {
            background-color: #000;
            color: #fff;
            position: absolute;
            width: 5.74rem;
            left: 0.7rem;
            box-sizing: border-box;
            padding: 0.32rem;
            line-height: 1.4;
            z-index: 2;
            &::before {
                position: absolute;
                width: 0rem;
                height: 0rem;
                content: "";
                border-left: 0.15rem solid transparent;
                border-right: 0.15rem solid transparent;
                border-bottom: 0.3rem solid #000;
                left: 50%;
                margin-left: -0.15rem;
                top: -0.3rem;
            }

            .row {
                position: relative;
                padding-left: 0.30rem;
                margin-bottom: 0.2rem;

                span {
                    position: absolute;
                    left: 0rem;
                    top: 0rem;
                }
            }
        }

        .input-wrapper {
            width: 5.5rem;
            margin: 0rem auto 0.21rem auto;
            box-sizing: border-box;
            padding-left: 0.32rem;

            &.textarea-wrapper {
                padding-top: 0.16rem;
                margin-bottom: 0.18rem;
            }

            input,
            textarea {
                height: 0.78rem;
                display: block;
                width: 100%;
                outline: none;
                border: none;
                background: none;
            }

            textarea {
                height: 1.4rem;
            }
        }

        .btn-confirm {
            width: 3rem;
            height: 1rem;
            margin: 0rem auto;
        }
    }
}

#myAddressPop {
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/myAddressPop.png');
        width: 7.02rem;
        height: 5.98rem;
        margin-left: -3.51rem;
        margin-top: -3rem;
        box-sizing: border-box;
        padding-top: 1.5rem;
        line-height: 1.4;

        ul {
            width: 5.7rem;
            margin: 0rem auto;
            padding-top: 0.4rem;

            li {
                display: flex;
                justify-content: space-between;
                margin-bottom: 0.4rem;

                span {
                    width: 2rem;
                }

                strong {
                    flex: 1;
                    text-align: right;
                }
            }
        }
    }
}

#addressConfirmPop {
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/addressConfirmPop.png');
        width: 7.02rem;
        height: 4.72rem;
        margin-left: -3.51rem;
        margin-top: -2.36rem;

        h1 {
            text-align: center;
            font-size: 0.26rem;
            padding-top: 1.4rem;
            font-weight: bold;
            line-height: 1.4;
        }
    }
}

#getRewardsPop {
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/getAllRewardsPop.png');
        width: 7.02rem;
        height: 4.72rem;
        margin-left: -3.51rem;
        margin-top: -2.36rem;

        h1 {
            font-size: 0.26rem;
            color: #151515;
            padding-top: 0.7rem;
            text-align: center;

            strong {
                color: #de381d;
            }
        }

        .myswiper {
            margin-top: 0.36rem;
        }

        .btns-wrapper {
            bottom: 0.64rem;
        }
    }
}

#getRewardsSuccessPop{
    .content{
        h1{
            padding-top: 1.06rem;
            padding-bottom: 0.2rem;
        }
        p{
            padding-top: 0rem;
            line-height: 1.4;
        }
    }
}
</style>